const translations = {};

translations["MSG_GUIDE"] = "ガイド";
translations["MSG_NETWORK_ERROR_MESSAGE"] =
  "ページを表示することができませんでした。\nもう一度試してみてください。";
translations["MSG_ERROR_NO_USER_TITLE"] = "ユーザーがありません";
translations["MSG_ERROR_NO_USER_MESSAGE"] = "ユーザーを追加してください";

translations["MSG_APP_ALL"] = "すべて";
translations["MSG_APP_BANNER_TITLE"] = "アプリ版『まなんでパズル』";
translations["MSG_APP_BANNER_SBUTITLE"] = "～子供も楽しくプログラミング教育～";
translations["MSG_APP_BANNER_INSTALL_BTN"] = "インストール";
translations["MSG_APP_BANNER_SHOW_BTN"] = "表示";

translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] =
  "アプリを最新版にアップデートします。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "最新版のアプリがあります。\n最新の機能を利用する為にアップデートが必要です。\nアップデートはすぐに完了します。";

translations["MSG_APP_ERROR_SIGN_IN_FAILED"] =
  "メールアドレスかパスワードが正しくありません。";
translations["MSG_APP_ERROR_EMAIL_NOT_VALID"] =
  "有効なメールアドレスを入力してください。";
translations["MSG_APP_ERROR_EMAIL_ALREADY_IN_USE"] =
  "入力されたメールアドレスは既に使用されています。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] =
  "6文字以上のパスワードを入力してください。";
translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] =
  "パスワードが一致していません。";

translations["MSG_SIGN_WITH_LINKED_PARENTS_ACCOUNT_NOTICE"] =
  "この端末のユーザーは既に下記のアカウントにリンクしているため、下記のアカウントでのみログインが可能です。";
translations["MSG_SIGN_WITH_LINKED_PARENTS_SSO_ACCOUNT_NOTICE"] =
  "この端末のユーザーは下記の他のサービスのアカウントでログイン連携されています。";
translations["MSG_SIGN_NOTICE"] =
  "お持ちのまなんでパズルアカウントにログインするか、アカウントを新しく作成してください";
translations["MSG_SIGN_INSTITUTION_NOTICE"] =
  "※ 教育機関の関係者の方 \n（教育機関コードをお持ちの方）は\n下記よりログインしてください。";
translations["MSG_SIGN_NOT_SIGN_IN"] = "※アカウントをお持ちでない方";
translations["MSG_SIGN_ALREADY_SIGN_IN"] = "※すでにアカウントをお持ちの方";
translations["MSG_SIGN_IN_BTN"] = "ログイン";
translations["MSG_SIGN_UP_BTN"] = "新規登録";
translations["MSG_SIGN_IN_ACCOUNT_BTN"] = "アカウントログイン";
translations["MSG_SIGN_UP_ACCOUNT_BTN"] = "アカウント登録";
translations["MSG_SIGN_IN_INSTITUTION_BTN"] = "教育機関ログイン";
translations["MSG_SIGN_OTHER_ACCOUNT"] = "ソーシャルアカウントで続ける";
translations["MSG_SIGN_IN_OTHER_ACCOUNT"] = "ソーシャルアカウントでログイン";
translations["MSG_SIGN_UP_OTHER_ACCOUNT"] = "ソーシャルアカウントで登録";
translations["MSG_SIGN_IN_WITH_APPLE"] = "Appleで続ける";
translations["MSG_SIGN_UP_WITH_APPLE"] = "Appleで続ける";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "Googleで続ける";
translations["MSG_SIGN_UP_WITH_GOOGLE"] = "Googleで続ける";
translations["MSG_SIGN_IN_WITH_MICROSOFT"] = "Microsoftで続ける";
translations["MSG_SIGN_UP_WITH_MICROSOFT"] = "Microsoftで続ける";
translations["MSG_SIGN_IN_WITH_X"] = "Xで続ける";
translations["MSG_SIGN_UP_WITH_X"] = "Xで続ける";
translations["MSG_SIGN_IN_WITH_FACEBOOK"] = "Facebookで続ける";
translations["MSG_SIGN_UP_WITH_FACEBOOK"] = "Facebookで続ける";
translations["MSG_SIGN_IN_WITH_MAIL"] = "メールでログイン";
translations["MSG_SIGN_UP_WITH_MAIL"] = "メールで登録する";
translations["MSG_SIGN_USER_INSTITUTION_CODE"] = "教育機関コード";
translations["MSG_SIGN_USER_MAIL"] = "メールアドレス";
translations["MSG_SIGN_USER_PASSWORD"] = "パスワード";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "パスワード再入力";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "ログイン成功しました。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "アカウント登録成功しました。";
translations["MSG_SIGN_IN_FAILED_TITLE"] = "ログイン失敗";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] =
  "メールアドレスかパスワードが間違っています。";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "パスワードが忘れた場合";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "パスワードリセット";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_SEND_BTN"] = "送信";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_SUCCESS_CONTENT"] =
  "指定したメールアドレスへパスワードリセットのリンクを送りました。";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] =
  "現在のパスワード";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] =
  "新しいパスワード";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] =
  "パスワードを確認";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SEND_BTN"] = "変更";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] =
  "パスワード変更成功しました。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] =
  "入力したパスワードが間違っています。";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_TITLE"] =
  "登録に失敗しました";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "このメールアドレスは既に利用されます。";
translations["MSG_SIGN_LOGOUT"] = "ログアウトしました。";
translations["MSG_SIGN_LOGOUT_FAILED"] = "ログアウト失敗しました。";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

translations["MSG_DATETIME_PERIOD"] = "期間";
translations["MSG_DATETIME_PERIOD_RECENTLY"] = "最近";
translations["MSG_DATETIME_FORMAT"] = "YYYY年MM月DD日";
translations["MSG_DATETIME_FORMAT_HOUR"] = "時";
translations["MSG_DATETIME_FORMAT_MINUTE"] = "分";

translations["MSG_INEXUS_OFFICIAL"] = "まなんでパズル";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "まなパズサポート";
translations["MSG_INEXUS_SYSTEM_NOTIFICATION"] = "システム";

translations["MSG_REVIEW_RATING_TITLE"] =
  "『まなんでパズル』の\n評価を\n教えてください！";
translations["MSG_REVIEW_FEEDBACK_TITLE"] = "ごいけんばこ";
translations["MSG_REVIEW_TITLE_THANKYOU"] = "ありがとうございました！";
translations["MSG_REVIEW_GOTO_FEEDBACK"] = "不満";
translations["MSG_REVIEW_GOTO_REVIEW"] = "評価";
translations["MSG_REVIEW_SEND_FEEDBACK_CANCEL"] = "キャンセル";
translations["MSG_REVIEW_SEND_RATING_CONFIRM"] = "送る";
translations["MSG_REVIEW_SEND_FEEDBACK_CONFIRM"] = "ご意見を送る";
translations["MSG_REVIEW_THANKS_BUBBLE_TEXT"] = "ありがとう\nございました！";
translations["MSG_REVIEW_RATING_THANKS_TEXT"] =
  "これからも、『まなんでパズル』を\nよろしくおねがいします。";
translations["MSG_REVIEW_FEEDBACK_THANKS_TEXT"] =
  "これからも、『まなんでパズル』を\nよろしくおねがいします。";

translations["MSG_REVIEW_FEEDBACK_TYPE_APP"] = "アプリ全体";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE"] = "『コースでまなぶ』";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR"] = "『じゆうにつくる』";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "不満はない";
translations["MSG_REVIEW_FEEDBACK_TYPE_OTHER"] = "その他";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] =
  "使い方が\nわからない";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "使いづらい";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "難しすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "簡単すぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] =
  "ステージが\n多すぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] =
  "ステージが\n少なすぎる";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] =
  "うまく\n作れない";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] =
  "使い方が\n難しい";
translations["MSG_REVIEW_FEEDBACK_PLACEHOLDER"] = "ここに自由に書いてください";

translations["MSG_USER_PROFILE_ADD_USER_BTN"] = "追加";
translations["MSG_USER_PROFILE_ADD_USER_TITLE"] = "ユーザーを追加します";
translations["MSG_USER_PROFILE_ADD_USER_SUCCESS"] = "ユーザーを追加しました";
translations["MSG_USER_PROFILE_ADD_USER_FAILED"] =
  "ユーザーの追加に失敗しました";
translations["MSG_USER_PROFILE_ADD_USER_MESSAGE"] =
  "新しいユーザーに名前を付けてください。";
translations["MSG_USER_PROFILE_CHANGE_USER"] = "ユーザー切り替え";
translations["MSG_USER_PROFILE_CHANGE_USER_TITLE"] =
  "ユーザーを切り替えますか？";
translations["MSG_USER_PROFILE_CHANGE_USER_MESSAGE"] =
  "ユーザーを「%{name}」に切り替えます。";
translations["MSG_USER_PROFILE_CHANGE_USER_SUCCESS"] =
  "ユーザーを切り替えました";
translations["MSG_USER_PROFILE_CHANGE_USER_FAILED"] = "ユーザー切り替え失敗";
translations["MSG_USER_PROFILE_MAX_USER_TITLE"] = "ユーザーを追加できません";
translations["MSG_USER_PROFILE_MAX_USER_MESSAGE"] =
  "現在はユーザーは４人までしかつくれません。\n４人以上ユーザーを作れるようになりましたら、お知らせします。";
translations["MSG_USER_PROFILE_SIGN_TITLE"] = "ユーザーを追加できません";
translations["MSG_USER_PROFILE_SIGN_MESSAGE"] =
  "ユーザーを追加するにはログインが必要です。\nログインは「保護者の方用」ボタンからできます。";
translations["MSG_USER_PROFILE_USER_STATUS"] = "ステータス";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "名前%{random}";
translations["MSG_USER_PROFILE_FIELD_NAME"] = "ニックネーム";
translations["MSG_USER_PROFILE_FIELD_NAME_PLACEHOLDER"] =
  "ニックネームを入れてください";
translations["MSG_USER_PROFILE_FIELD_GENDER"] = "性別";
translations["MSG_USER_PROFILE_FIELD_GENDER_MALE"] = "男性";
translations["MSG_USER_PROFILE_FIELD_GENDER_FEMALE"] = "女性";
translations["MSG_USER_PROFILE_FIELD_GENDER_NONE"] = "なし";
translations["MSG_USER_PROFILE_FIELD_GENDER_ALL"] = "すべて";
translations["MSG_USER_PROFILE_FIELD_AGE"] = "年齢";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY"] = "誕生日";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_YEAR"] = "年";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH"] = "月";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DAY"] = "日";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE"] = "歳";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH_ERROR"] =
  "1 ~ 12の間の数字を使ってください";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DAY_ERROR"] =
  "1 ~ 31の間の数字を使ってください";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE_ERROR"] =
  "0 ~ 99の間の数字を使ってください";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_NOT_SETTING"] = "ー";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_MONTH_PLACEHOLDER"] = "1";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_DATE_PLACEHOLDER"] = "1";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY_AGE_PLACEHOLDER"] = "0";
translations["MSG_USER_PROFILE_STATUS_CREATED"] = "はじめた日";
translations["MSG_USER_PROFILE_STATUS_PERIOD"] = "ログイン\n日数";
translations["MSG_USER_PROFILE_STATUS_DAY"] = "日";
translations["MSG_USER_PROFILE_STATUS_COURSE_CLEARED"] = "クリアした\nコース";
translations["MSG_USER_PROFILE_STATUS_PROJECTS"] = "作った\nアプリ";
translations["MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS"] = "公開した\nアプリ";
translations["MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE"] =
  "もらった\nいいねの数";
translations["MSG_USER_PROFILE_PROGRESS"] = "記\n録";
translations["MSG_USER_PROFILE_PROGRESS_NEW_TITLE"] = "New!";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_LEVEL_TITLE"] = "レベル";
translations["MSG_USER_PROFILE_PROGRESS_COURSE"] = "コースで\nまなぶ";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_DATE_TITLE"] = "日目";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_CLEARED_TITLE"] =
  "レベル\nクリア";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_TITLE"] = "クリアした数";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_PROGRESS_TITLE"] =
  "ここまでできたよ！";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR"] = "じゆうに\nつくる";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_START"] =
  "合計";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_END"] = "人";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_START"] =
  "合計";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_END"] =
  "いいね";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_NEW_TITLE"] =
  "あたらしい\nいいね";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_AVG_TITLE"] =
  "いいね\n平均";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_VIEWED_TITLE"] =
  "見に来た人";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_FAVORITED_TITLE"] =
  "いいねの数";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY"] =
  "アプリをつくりましょう！";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_GOTO_BTN"] =
  "『じゆうにつくる』へ";
translations["MSG_USER_PROFILE_INFO"] = "自分";
translations["MSG_USER_PROFILE_ICON"] = "写真";
translations["MSG_USER_PROFILE_ICON_BTN"] = "アイコンを変更";
translations["MSG_USER_PROFILE_CASE_BTN"] = "ケースを変更";
translations["MSG_USER_PROFILE_CURRENT_ICON"] = "今のアイコン";
translations["MSG_USER_PROFILE_STOCK"] = "そざい";
translations["MSG_USER_PROFILE_CASE"] = "持ち物";
translations["MSG_USER_PROFILE_CASE_TITLE"] = "ケースの色";
translations["MSG_USER_PROFILE_CURRENT_CASE"] = "今のケース";
translations["MSG_USER_PROFILE_SETTING"] = "設定";
translations["MSG_USER_PROFILE_NAME_ERROR_TITLE"] = "登録ができませんでした。";
translations["MSG_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "使う事のできない文字や文章が含まれています。もう一度やり直してください。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_TITLE"] =
  "登録ができませんでした。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "使う事のできない文字や文章が含まれています。もう一度やり直してください。";
translations["MSG_USER_PROFILE_MESSAGE"] = "郵便";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TITLE"] =
  "%{type}のお問い合わせ";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "お問合せありがとうございます！\n下の入力枠にお問合せの内容を書いてください。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_INPUT_AUTO_REPLY"] =
  translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"];
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_CONTENT"] = "質問内容：\n";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_REPLY_TITLE"] =
  "お問い合わせの返信がありました。";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_REPLY_CONTENT"] = "返信内容：\n";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TAG"] = "お問い合わせ";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_REPLY_TAG"] = "お問い合わせ";
translations["MSG_USER_PROFILE_MESSAGE_PUSH_TAG"] = "お知らせ";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TITLE"] =
  "『まなんでパズル』へ ようこそ！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_0"] =
  "%{name}さん、『まなんでパズル』へ ようこそ！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_1"] =
  "『まなんでパズル』では、パズルのように 楽しく 遊びながら プログラミングを 勉強できます。\nまずは、順番に 遊び方や 勉強の方法を 覚えるために、『コースでまなぶ』から始めて みてください！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_2"] =
  "アルゴリズムやプログラムの やりかたが だいたい分かったところで、『じゆうにつくる』で、自分の思うままに アプリを作ってみてください。";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_3"] =
  "さぁ、『まなんでパズル』を レッツトライ！";
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] =
  "が参加しました。";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_SEND_BTN"] = "送る";
translations["MSG_USER_PROFILE_MESSAGE_TYPE_IMAGE"] = "画像";
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_WELCOME_TEXT"] =
  "トークしましょう";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING"] = "の評価を送りました。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING_AUTO_REPLY"] =
  "評価ありがとうございました！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_AUTO_REPLY"] =
  "ご意見ありがとうございました！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TITLE"] = "ご意見";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TYPE_OTHER"] =
  "・そのた：";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER"] =
  "ここに自由に書いてください";
translations["MSG_USER_PROFILE_MESSAGE_PUBLISHED_PROJECT_MESSAGE"] =
  "アプリ「%{name}」を公開しました。";

translations["MSG_TOP_TUTORIAL_FIRST_WELCOM_MESSAGE"] =
  "はじめてのひとは\nチュートリアルを\nみてね！";
translations["MSG_TOP_TUTORIAL_WELCOM_MESSAGE_1"] =
  "きょうもいっしょに\nがんばろう！";
translations["MSG_TOP_TUTORIAL_WELCOM_MESSAGE_2"] =
  "たのしくパズルで\nまなぼうね！";
translations["MSG_TOP_TUTORIAL_WELCOM_MESSAGE_3"] =
  "ぼくといっしょに\nプログラミングを\nまなぼう！";
translations["MSG_TOP_TUTORIAL_APP_START"] = "はじめる";
translations["MSG_TOP_TUTORIAL_START"] = "チュートリアルをみる";
translations["MSG_TOP_TUTORIAL_DONOT_SHOW"] = "次回から表示しない";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_1"] = "「まなんでパズル」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_2"] = "「コースでまなぶ」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_3"] = "「じゆうにつくる」\nについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_4"] = "ヘルプボタンと\nマイページ";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_5"] =
  "保護者の方用の\nメニューについて";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_6"] = "アプリの設定を\n行う";
translations["MSG_TOP_TUTORIAL_CLOSE_PAGE"] = "この画面を閉じる";
translations["MSG_TOP_TUTORIAL_NEXT_PAGE"] = "次へ";
translations["MSG_TOP_TUTORIAL_START_APP"] = "『まなんでパズル』を始める";

translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "お知らせ";

translations["MSG_BACK_BTN"] = "もどる";
translations["MSG_CLOSE_BTN"] = "とじる";
translations["MSG_CANCEL_BTN"] = "キャンセル";
translations["MSG_CONFIRM_BTN"] = "決定";
translations["MSG_STOP_BTN"] = "やめる";
translations["MSG_DELETE_BTN"] = "削除する";

translations["MSG_PARENTS_BACK_BTN"] = "戻る";
translations["MSG_PARENTS_CLOSE_BTN"] = "閉じる";
translations["MSG_PARENTS_CANCEL_BTN"] = "キャンセル";
translations["MSG_PARENTS_CONFIRM_BTN"] = "決定";
translations["MSG_PARENTS_DELETE_BTN"] = "削除";
translations["MSG_PARENTS_KIDS_USER_DELETE_BTN"] = "このユーザーの削除";

translations["MSG_ERROR_RELOAD_BTN"] = "やりなおす";
translations["MSG_ERROR_TITLE"] =
  "正しく処理を完了することができませんでした。";
translations["MSG_ERROR_MESSAGE"] =
  "もう一度やり直してください。\nやり直してもこの画面が出る場合は、保護者の人に相談してください。";
translations["MSG_DATE_STRING"] = "%{year}年%{month}月%{day}日";

translations["MSG_TOAST_FAILED"] = "失敗しました";
translations["MSG_TOAST_SEND_FAILED"] = "送信失敗しました";
translations["MSG_TOAST_SUCCESS"] = "成功しました";
translations["MSG_TOAST_EDIT_SUCCESS"] = "変更しました";
translations["MSG_TOAST_DELETED_SUCCESS"] = "削除しました";
translations["MSG_TOAST_PUBLISHED_SUCCESS"] = "公開しました";
translations["MSG_TOAST_DISABLE_PUBLISHED_SUCCESS"] = "公開をやめました";
translations["MSG_TOAST_ENABLE_COPIED_SUCCESS"] = "コピーを許可しました";
translations["MSG_TOAST_DISABLE_COPIED_SUCCESS"] =
  "コピーを許可しないにしました";
translations["MSG_TOAST_RESTORE_SUCCESS"] = "アプリを戻しました";
translations["MSG_TOAST_COPY"] = "コピーしました。";
translations["MSG_TOAST_PAST"] = "ペーストしました。";
translations["MSG_TOAST_UNDO"] = "元に戻しました。";
translations["MSG_TOAST_REDO"] = "やり直しました。";
translations["MSG_TOAST_INSERT_ASSET_IMAGE_SUCCESS"] = "画像を追加しました。";
translations["MSG_TOAST_INSERT_ASSET_TEMPLATE_SUCCESS"] =
  "テンプレートを追加しました。";
translations["MSG_TOAST_CONTACT_SEND"] = "お問い合わせ内容を送信しました";

translations["MSG_SETTING_NOTIFICATION"] = "お知らせ";
translations["MSG_SETTING_TOP_TUTORIAL"] = "アプリの起動画面";
translations["MSG_SETTING_TOP_TUTORIAL_SHOW"] = "最初に表示";
translations["MSG_SETTING_TOP_TUTORIAL_NOT_SHOW"] = "表示しない";
translations["MSG_SETTING_APP_LANGUAGE"] = "アプリの表示言語";
translations["MSG_SETTING_SOUND"] = "効果音";
translations["MSG_SETTING_BGM"] = "音楽";
translations["MSG_SETTING_PARENT_GATE"] = "保護者の方用";
translations["MSG_SETTING_GO_TO_TOP"] = "トップページ";
translations["MSG_SETTING_GO_TO_CONTACT"] = "お問い合せ";
translations["MSG_SETTING_GO_TO_FEEDBACK"] = "フィードバック";
translations["MSG_SETTING_GO_TO_REVIEW"] = "アプリの評価";
translations["MSG_SETTING_GO_TO_TUTORIAL"] = "チュートリアル";
translations["MSG_SETTING_GO_TO_PARENTS_LINK"] = "みまもりアプリ";
translations["MSG_SETTING_GO_TO_LAB"] = "企業認証コード入力";
translations["MSG_SETTING_GO_TO_MYPAGE_SETTING"] = "設定ページ";
translations["MSG_SETTING_CLOSE_BTN"] = "この画面を閉じる";
translations["MSG_SETTING_BACK_TO_BTN"] = "前の画面に戻る";

translations["MSG_SETTING_TITLE_TOP"] = "保護者メニュー";
translations["MSG_SETTING_CATEGORY_TITLE_APP_ACCOUNT"] = "アカウント";
translations["MSG_SETTING_CATEGORY_TITLE_APP_CONTENT"] = "コンテンツ";
translations["MSG_SETTING_CATEGORY_TITLE_APP_INFO"] = "アプリ";
translations["MSG_SETTING_CATEGORY_TITLE_APP_LINK"] = "追加のアプリ";
translations["MSG_SETTING_TITLE_APP_SETTING"] = "アプリの設定";
translations["MSG_SETTING_TITLE_DATA_TRANSFER"] = "データの同期";
translations["MSG_SETTING_TITLE_DATA_DELETE"] = "ユーザーの削除";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "コースの解答を見る";
translations["MSG_SETTING_TITLE_PARENTS_LINK"] = "みまもりアプリ";
translations["MSG_SETTING_TITLE_ENABLE_LAB"] = "コンテンツ認証";
translations["MSG_SETTING_TITLE_CLASSROOM"] = "クラスルーム";
translations["MSG_SETTING_TITLE_PARENTS_USER_ACCOUNT"] = "アカウントの管理";
translations["MSG_SETTING_TITLE_PARENTS_USER_PROFILE"] = "ユーザーの管理";
translations["MSG_SETTING_TITLE_SUBSCRIPTION"] = "プラン購入";
translations["MSG_SETTING_TITLE_SIGN"] = "まなんでパズルアカウント";
translations["MSG_SETTING_TITLE_SIGN_IN"] = "アカウントログイン";
translations["MSG_SETTING_TITLE_INSTITUTION_SIGN_IN"] = "教育機関ログイン";
translations["MSG_SETTING_TITLE_SIGN_UP"] = "アカウント登録";
translations["MSG_SETTING_TITLE_SIGN_ACCOUNT"] = "アカウントログイン/登録";
translations["MSG_SETTING_TITLE_SIGN_IN_MAIL"] = "アカウントログイン";
translations["MSG_SETTING_TITLE_SIGN_UP_MAIL"] = "アカウント登録";
translations["MSG_SETTING_TITLE_SIGN_PASSWORD_RESET"] = "パスワードリセット";
translations["MSG_SETTING_TITLE_SIGN_PASSWORD_CHANGE"] = "パスワード変更";
translations["MSG_SETTING_TITLE_SIGN_PROFILE"] = "プロフィール";
translations["MSG_SETTING_TITLE_PARENTS_USER_UNSUBSCRIBE"] = "アカウント削除";
translations["MSG_SETTING_TITLE_NOTIFICATION"] = "お知らせ";

translations["MSG_SETTING_MENU_APP_SETTING_BTN"] =
  translations["MSG_SETTING_TITLE_APP_SETTING"];
translations["MSG_SETTING_MENU_NOTIFICATION"] = "プッシュ通知設定";
translations["MSG_SETTING_MENU_PROJECT_PUBLISH"] = "アプリの公開を許可する";
translations["MSG_SETTING_MENU_PROJECT_COPIED"] =
  "アプリがコピーされることを許可する";
translations["MSG_SETTING_MENU_LANGUAGE"] = "アプリの表示言語";
translations["MSG_SETTING_MENU_DATA_TRANSFER_BTN"] =
  translations["MSG_SETTING_TITLE_DATA_TRANSFER"];
translations["MSG_SETTING_MENU_DATA_DELETE_BTN"] =
  translations["MSG_SETTING_TITLE_DATA_DELETE"];
translations["MSG_SETTING_MENU_COURSE_ANSWER_BTN"] = "コースの解答\nを見る";
translations["MSG_SETTING_MENU_NOTIFICATION_TITLE"] =
  translations["MSG_SETTING_TITLE_NOTIFICATION"];
translations["MSG_SETTING_MENU_PARENTS_USER_BTN"] =
  translations["MSG_SETTING_TITLE_PARENTS_USER_PROFILE"];
translations["MSG_SETTING_MENU_SIGN_BTN"] =
  translations["MSG_SETTING_TITLE_SIGN"];
translations["MSG_SETTING_MENU_SIGN_WARNING_TITLE"] = "ログインが必要です";
translations["MSG_SETTING_MENU_SIGN_WARNING_MESSAGE"] =
  "この機能を使うには先にログインをしてください。";

translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "『まなんでパズル』のサイトへ";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "ご利用規約";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "プライバシーポリシー";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "お問い合わせ";

translations["MSG_SETTING_APP_SETTING_LANGUAGE"] = "アプリの表示言語";
translations["MSG_SETTING_APP_SETTING_CONFIRM"] =
  "アプリの表示言語を\n「%{language}」に変更しますか？";
translations["MSG_SETTING_APP_SETTING_USER_ACTIVE"] = "このユーザーの有効化";

translations["MSG_SETTING_DATA_DELETE_CONFIRM_TITLE"] =
  "ユーザーを削除しますか？";
translations["MSG_SETTING_DATA_DELETE_CONFIRM_MESSAGE"] =
  "ユーザー「%{name}」を削除します。\n【注意】削除するとコースのクリアデータや作成したアプリなどのすべてのデータが削除されます。";
translations["MSG_SETTING_DATA_DELETE_TITLE"] = "この端末のユーザーを削除する";
translations["MSG_SETTING_DATA_DELETE_WARNING_TEXT"] =
  "上で選んだユーザーを削除すると、右に表示されているデータが全て削除されます。\n削除したユーザーは元に戻すことはできませんので、十分ご注意ください。\n※ 最初に作成したユーザーは削除できません。";
translations["MSG_SETTING_DATA_DELETE_DATA_PROGRESS"] = "こ ／%{total}こ";
translations["MSG_SETTING_DATA_DELETE_COURSE_TITLE"] = "コースでまなぶ";
translations["MSG_SETTING_DATA_DELETE_COURSE_CLEAR"] = "クリアした\nレベル";
translations["MSG_SETTING_DATA_DELETE_CREATOR_TITLE"] = "じゆうにつくる";
translations["MSG_SETTING_DATA_DELETE_DEFAULT_USER_TITLE"] =
  "ユーザーを削除できません。";
translations["MSG_SETTING_DATA_DELETE_DEFAULT_USER_MESSAGE"] =
  "最初に作成したユーザー「%{name}」は削除できません。";
translations["MSG_SETTING_DATA_DELETE_SUCCESS"] = "ユーザーの削除しました";
translations["MSG_SETTING_DATA_DELETE_BTN"] = "ユーザーを削除する";

translations["MSG_SETTING_PARENTS_ADD_KIDS_USER_TITLE"] =
  "ユーザーを取り込みます";
translations["MSG_SETTING_PARENTS_ADD_KIDS_USER_MESSAGE"] =
  "ログイン中のアカウントにこの端末のユーザを追加します。\nユーザーの追加を行うと、この端末のユーザーはログイン中のアカウントに移動します。";
translations["MSG_SETTING_PARENTS_MAX_USER_TITLE"] = "ユーザーを追加できません";
translations["MSG_SETTING_PARENTS_MAX_USER_MESSAGE"] =
  "現在はユーザーは４人までしかつくれません。\n４人以上ユーザーを作れるようになりましたら、お知らせします。";
translations["MSG_SETTING_PARENTS_LINKED_ACCOUNT_WRONG_TITLE"] =
  "ログインに失敗しました";
translations["MSG_SETTING_PARENTS_LINKED_ACCOUNT_WRONG_MESSAGE"] =
  "この端末のユーザーがリンクしているアカウントと異なるソーシャルアカウントが使用されました。\nもう一度正しいソーシャルアカウント選択してやり直してください。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_TITLE"] =
  "ユーザーの有効化を行います";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MESSAGE"] =
  "このユーザーを有効にします。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] =
  "有効化できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "有効化できるユーザーの数は最大４人までです。\nこのユーザーを有効化する場合には、ほかの不要なユーザーを無効化（もしくは削除）を行なってください。";
translations["MSG_SETTING_PARENTS_ADD_DEVICE_USER_MAX_WARNING_TITLE"] =
  "続いて追加したユーザーの有効化状態を確認してください";
translations["MSG_SETTING_PARENTS_ADD_DEVICE_USER_MAX_WARNING_MESSAGE"] =
  "ログイン中のアカウントのユーザー数が合計4名を超えました。\n同時に有効化できるユーザーの数は最大4名までです。\n今回追加したユーザーを有効化する場合には、ほかの不要なユーザーを無効化（もしくは削除）を行ってください。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] =
  "変更できません";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "最低でも１名のユーザーが必要です。\nこれ以上ユーザーを減らすことはできません。";
translations["MSG_SETTING_PARENTS_REMOVE_KIDS_USER_TITLE"] =
  "ユーザーを削除します";
translations["MSG_SETTING_PARENTS_REMOVE_KIDS_USER_MESSAGE"] =
  "ユーザーを削除すると、このユーザーのデータは全て削除されます。\nもうこのユーザーを利用することはできなくなります。";
translations["MSG_SETTING_PARENTS_REMOVE_KIDS_MIN_WARNING_TITLE"] =
  "削除できません";
translations["MSG_SETTING_PARENTS_REMOVE_KIDS_MIN_WARNING_MESSAGE"] =
  "最低でも１名のユーザーが必要です。これ以上ユーザーを減らすことはできません。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "ログアウトします";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "・アカウントをログアウトすると、今お使いのユーザーで遊ぶことができなくなります。\n・ユーザーの情報はアカウントに保存されますので、また同じユーザーで遊びたい場合は、このアカウントで再度ログインを行ってください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] =
  "【重要】ご注意ください";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "『まなんでパズル』からアカウント削除すると、下記のデータの全てが削除されます。\n・登録したプロフィール情報やアカウント情報。\n・登録した全員分のユーザー情報。\n・ユーザーが作成した「じゆうにつくる」のアプリ。\n・ユーザーがクリアした「コースでまなぶ」の全ての成績やクリア実績。\n・ユーザーが行ってきた「トーク履歴」等。\n※ 【重要】ログインしているアカウントの削除を行うと、本アカウントに関連するすべてのデータ削除されますので、十分にご注意ください。\n※ 【重要】この作業はいかなる場合も復旧することはできません。アカウントを削除する場合は十分にご注意ください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] =
  "アカウント削除の理由を教えてください。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] =
  "本当にアカウント削除しますか？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "アカウント削除するとアカウント・ユーザーを含むすべてのデータが削除されます。\nアカウント削除処理は復旧することができません。ご注意ください。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_NAME"] = "表示名";
translations["MSG_SETTING_PARENTS_USER_PROFILE_SAVE_BTN"] = "保存";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL"] = "メールアドレス";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED"] = "メール確認";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED_DONE"] =
  "確認済み";
translations["MSG_SETTING_PARENTS_USER_PROFILE_EMAIL_VERIFIED_NOT_YET"] =
  "認証リンクを送る";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT"] =
  "ソーシャルアカウント\nとの連携";
translations[
  "MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"
] = "連携ができません";
translations[
  "MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"
] = "ソーシャルアカウントはすでに別のアカウントと連携しました。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_WITH_APPLE"] =
  "Appleと連携";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_WITH_GOOGLE"] =
  "Googleと連携";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_WITH_EMAIL"] =
  "パスワードを設定";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_UNLINK_WITH_APPLE"] =
  "Apple連携を解除";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_UNLINK_WITH_GOOGLE"] =
  "Google連携を解除";
translations["MSG_SETTING_PARENTS_USER_PROFILE_CREATED_AT"] =
  "アカウント登録日";
translations["MSG_SETTING_PARENTS_USER_KIDS_PROFILE_CREATED_AT"] = "登録日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_LATEST_AT"] = "最後ログイン日";
translations["MSG_SETTING_PARENTS_USER_PROFILE_GOTO_CHANGE_PASSWORD_BTN"] =
  "パスワード変更";
translations["MSG_SETTING_PARENTS_USER_PROFILE_SIGN_OUT_BTN"] = "ログアウト";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] =
  "アカウント削除";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ADD_USER"] = "新規ユーザー追加";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ADD_DEVICE_USER"] =
  "端末ユーザー追加";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ADD_DEVICE_USER_TO_ACCOUNT"] =
  "アカウントに追加";
translations["MSG_SETTING_PARENTS_USER_PROFILE_DISPLAY_NAME_LIMIT"] =
  "%{limit}文字以内で入力してください。";

translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "コースを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "ステージを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "レベルを選ぶ";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "ステージ";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "レベル";

translations["MSG_SETTING_PARENTS_LINK_DOWNLOAD_TITLE"] =
  "みまもりアプリをアプリストアからダウンロード";
translations["MSG_SETTING_PARENTS_LINK_DOWNLOAD_DESCRIPTION"] =
  "QRコードを利用せずにアプリをダウンロードする場合は、下記のアイコンより各アプリストアにてダウンロードしてください。";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_TITLE"] =
  "ユーザをみまもりりアプリに追加";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_DESCRIPTION"] =
  "QRコードを利用せずにユーザーを追加したい場合は、こちらの認証コードを『みまもりアプリ』に入力してください。";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] =
  "認証コード";

translations["MSG_CONTACT_TITLE"] = "おといあわせ";
translations["MSG_CONTACT_TYPE_TITLE"] = "お問い合わせの種類を選んでください";
translations["MSG_CONTACT_DETAIL_TITLE"] =
  "お問い合わせの内容を詳しく教えてください";
translations["MSG_CONTACT_TYPE_HOW_TO"] = "使い方が\nわからない";
translations["MSG_CONTACT_TYPE_BUG"] = "うまく\n動かない";
translations["MSG_CONTACT_TYPE_REQUEST"] = "追加して\nほしい機能";
translations["MSG_CONTACT_TYPE_OTHER"] = "その他の\n質問";
translations["MSG_CONTACT_SEND_BTN"] = "お問い合わせを送る";

translations["MSG_PARENT_GATE_WARNING"] =
  "このページは\nおとなのひとに\nかくにんして\nもらってくださいね";
translations["MSG_PARENT_GATE_TITLE"] = "保護者の方へ";
translations["MSG_PARENT_GATE_DESCRIPTION"] =
  "この先の画面は、保護者の方向けの設定・アカウント情報ペー\nジとなります。\n画面を表示するには、以下の画像を指示のとおりタップしてか\nら進むボタンを押してください。";
translations["MSG_PARENT_GATE_CLOSE_BTN"] =
  translations["MSG_SETTING_CLOSE_BTN"];
translations["MSG_PARENT_GATE_CONFIRM_BTN"] = "進む";
translations["MSG_PARENT_GATE_QUESTION_TITLE"] =
  "画像をこの順番でタップしてください:";
translations["MSG_PARENT_GATE_SHAPE_RECT"] = "四角";
translations["MSG_PARENT_GATE_SHAPE_STAR"] = "星型";
translations["MSG_PARENT_GATE_SHAPE_CIRCLE"] = "円形";
translations["MSG_PARENT_GATE_SHAPE_TRIANGLE"] = "三角";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "保護者";

translations["MSG_COURSE_COMING_SOON_WARNING_MESSAGE"] =
  "このカセットは まだ遊べないよ。\nもうちょっと待ってね！";
translations["MSG_COURSE_START_BTN"] = "スタート";
translations["MSG_COURSE_GOTO_MAP_BTN"] = "マップへ";
translations["MSG_COURSE_STGAE_CLEAR_TITLE"] = "ここまでクリア！";
translations["MSG_COURSE_DESCRIPTION"] =
  "あひるクンといっしょに、パズルでたのしくアルゴリズムをまなびましょう！";
translations["MSG_COURSE_LEVEL_OVERVIEW_SUMMARY"] = "このレベルでまなぶこと";
translations["MSG_COURSE_LEVEL_OVERVIEW_START_BTN"] = "はじめる";
translations["MSG_COURSE_GAME_TIPS_NEXT_BTN"] = "つぎへ";
translations["MSG_COURSE_GAME_TIPS_BACK_BTN"] = "まえにもどる";
translations["MSG_COURSE_GAME_TIPS_ACTION_BTN"] = "やってみる";
translations["MSG_COURSE_GAME_HINT_BTN"] = "ヒント";
translations["MSG_COURSE_GAME_CLEAR"] = "クリア";
translations["MSG_COURSE_GAME_SCORE_TEXT"] = "てにいれたアイテム";
translations["MSG_COURSE_GAME_SCORE_STATUS"] = "こ/%{total}こ";
translations["MSG_COURSE_GAME_START_BTN"] = "スタート！";
translations["MSG_COURSE_GAME_RESET_BTN"] = "やりなおす";
translations["MSG_COURSE_GAME_SUCCESS_TEXT"] =
  "おめでとう!このレベルをクリアしたよ!";
translations["MSG_COURSE_GAME_SUCCESS_REVIEW_BTN"] = "みなおす";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN"] = "つぎのレベルにすすむ";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_STAGE_BTN"] =
  "つぎのステージにすすむ";
translations["MSG_COURSE_GAME_FAILED_TITLE"] = "ざんねん！";
translations["MSG_COURSE_GAME_FAILED_TEXT"] =
  "もう一回やってみましょう！\n\n難しくてわからない時は、\nヒントを参考にしてください。";
translations["MSG_COURSE_GAME_FAILED_RESET_BTN"] = "もういっかいやる";
translations["MSG_COURSE_GAME_STAGE_CLEAR"] =
  "おめでとう!ステージをクリアしたよ!";
translations["MSG_COURSE_GAME_STAGE_CLEAR_OK"] = "OK";
translations["MSG_COURSE_ALL_GAME_STAGE_CLEAR"] =
  "おめでとう！\nいま ちょうせんできる\nすべての ステージを クリアしたよ！\nあたらしい ステージが ついか されるまで\nたのしみに まっていてね！";
translations["MSG_COURSE_PROGRAM_RUN"] = "スタート";
translations["MSG_COURSE_COORDINATE_X"] = "横の位置（X座標）";

translations["MSG_CREATOR_TOP_TUTORIAL_MENU_TITLE"] = "使い方の説明";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_NEXT_BTN"] = "つぎへ";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_BACK_BTN"] = "まえにもどる";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_LATER_BTN"] = "あとで見る";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CONTINUE_BTN"] = "ガイドを続ける";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_ACTION_BTN"] = "やってみる";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CLOSE_BTN"] = "ガイドを終わる";
translations["MSG_CREATOR_DISPLAY_DEFAULT"] = "カセットを選んでください";
translations["MSG_CREATOR_CREATE_APP"] = "あたらしくつくる";
translations["MSG_CREATOR_CREATE_APP_TITLE"] = "アプリを作る";
translations["MSG_CREATOR_CREATE_APP_NAME"] = "アプリに名前をつけてください。";
translations["MSG_CREATOR_CREATE_APP_NAME_PREFIX"] = "アプリ";
translations["MSG_CREATOR_CREATE_TAG_TITLE"] = "タグをつくる";
translations["MSG_CREATOR_CREATE_TEMPLATE_NAME_PREFIX"] = "テンプレート";
translations["MSG_CREATOR_CREATE_APP_LIMIT"] = "つくれるアプリのかず";
translations["MSG_CREATOR_CREATE_APP_LIMIT_PROGRESS"] = "こ ／%{total}こ";
translations["MSG_CREATOR_APP_DETAIL_BTN"] = "詳しく";
translations["MSG_CREATOR_RUN_APP_BTN"] = "うごかす";
translations["MSG_CREATOR_APP_MY_APPS"] = "マイアプリ";
translations["MSG_CREATOR_CREATE_MORE_APP_BTN"] = "もっと\nつくる";
translations["MSG_CREATOR_APP_SHARED_APPS"] = "みんなのアプリ";
translations["MSG_CREATOR_APP_SHARED_APPS_EMPTY_MESSAGE"] =
  "この条件のアプリがありませんでした。\n条件を変えて、もう一度検索をしてください。";
translations["MSG_CREATOR_APP_FAVORITED_APPS"] = "おきにいり";
translations["MSG_CREATOR_APP_DELETED_APPS"] = "ゴミ箱";
translations["MSG_CREATOR_APP_DELETED_APPS_MESSAGE"] =
  "「マイアプリ」に戻したいアプリを\n選んでください。\n（最近削除したアプリが\n5つまで残っています）";
translations["MSG_CREATOR_APP_PREVIEW_NOT_SELECTED"] =
  "アプリを選択するとここにプレビューが表示されるよ！";
translations["MSG_CREATOR_APP_SETTING_TITLE"] = "アプリの設定";
translations["MSG_CREATOR_APP_SETTING_APP_NAME"] = "アプリの名前";
translations["MSG_CREATOR_APP_SETTING_APP_TAG"] = "タグ";
translations["MSG_CREATOR_APP_SETTING_APP_TAG_CREATE_BTN"] = "タグ追加";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_TITLE"] =
  "みんなのアプリにのせる";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_OFF"] = "非公開";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_ON"] = "公開";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_TITLE"] =
  "他の人がコピーできる";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_OFF"] =
  "コピーを\n禁止する";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_ON"] =
  "コピーを\n許可する";
translations["MSG_CREATOR_APP_SETTING_APP_CHANGE_COVER_PAGE_BTN"] =
  "表紙を変更";
translations["MSG_CREATOR_APP_DETAIL_TITLE"] = "詳しい情報";
translations["MSG_CREATOR_APP_DETAIL_APP_AUTHOR"] = "はじめに作った人";
translations["MSG_CREATOR_APP_DETAIL_APP_EDITOR"] = "作り変えた人";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "名前を入れてください";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_TITLE"] = "アプリの説明";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_NONE"] = "説明がありません";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_PLACEHOLDER"] =
  "アプリの説明を入力してください";
translations["MSG_CREATOR_APP_DETAIL_INPUT_LIMIT"] = "%{input}／%{total}文字";
translations["MSG_CREATOR_APP_DETAIL_TITLE_APP_CODE"] = "アプリ\nコード";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP"] = "みんなの\nアプリ";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_PUBLISHED"] = "公開中";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_NOT_PUBLISHED"] =
  "非公開";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS"] = "ほかの\n人";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_ENABLE"] =
  "コピーできる";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_DISABLE"] =
  "コピーできない";
translations["MSG_CREATOR_APP_DETAIL_APP_DELETED_AT"] = "削除\nした日";

translations["MSG_CREATOR_APP_EDITED_DATE"] = "最後に\n作った日";
translations["MSG_CREATOR_APP_CREATED_DATE"] = "最初に\n作った日";
translations["MSG_CREATOR_APP_LATEST_AUTHOR"] = "最後に\n作った人";
translations["MSG_CREATOR_APP_ORIGINAL_AUTHOR"] = "最初に\n作った人";
translations["MSG_CREATOR_APP_EDITOR_BTN"] = "つくる";
translations["MSG_CREATOR_APP_COPY_EDITOR_BTN"] = "コピーしてつくる";
translations["MSG_CREATOR_APP_COMPLETELY_BTN"] = "完全に消す";
translations["MSG_CREATOR_APP_RESTORE_BTN"] = "元に戻す";
translations["MSG_CREATOR_APP_DELETE_WARNING_TITLE"] = "アプリを削除しますか？";
translations["MSG_CREATOR_APP_DELETE_WARNING_MESSAGE"] =
  "「%{name}」を削除します。\nアプリを編集できなくなります。\nアプリを使うことはできません。";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "画像を削除しますか？";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  "「%{name}」を 削除します。\n画像を削除すると、元に戻せなくなります。";
translations["MSG_CREATOR_TAG_DELETE_WARNING_TITLE"] = "タグを削除しますか？";
translations["MSG_CREATOR_TAG_DELETE_WARNING_MESSAGE"] =
  "タグ「%{name}」を 削除します。\nタグを削除すると、元に戻せなくなります。";
translations["MSG_CREATOR_CREATE_APP_PICKUP_NAME"] = "ピックアップ";
translations["MSG_CREATOR_CREATE_APP_PICKUP_MONTH_TITLE"] = "%{month}月の";
translations["MSG_CREATOR_CREATE_APP_PICKUP_SUBTITLE"] =
  "きになるアプリをごしょうかい！";

translations["MSG_CREATOR_APP_PUBLISH_SETTING_TITLE"] = "公開設定";
translations["MSG_CREATOR_APP_PUBLISH_BTN"] = "公開";
translations["MSG_CREATOR_APP_PUBLISH_TITLE"] =
  "「みんなのアプリ」に公開しますか？";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_TITLE"] =
  "アプリの公開ができません";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_MESSAGE"] =
  "アプリの公開が許可されていません。\n保護者メニューから許可をしてください。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_TITLE"] =
  "「みんなのアプリ」への公開をやめますか？";
translations["MSG_CREATOR_APP_PUBLISH_WARNING"] =
  "「%{name}」を「みんなのアプリ」に公開します。\nアプリを公開すると、ほかの人がこのアプリを使うことができるようになります。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_WARNING"] =
  "「%{name}」を「みんなのアプリ」に公開しないようにします。\n公開をやめると、ほかの人がこのアプリを使えなくなります。";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_ENABLE"] = "コピーを許可して公開";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_DISABLE"] =
  "コピーを許可しないで公開";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_NOTICE"] =
  "※アプリは後で公開をやめることもできます。";
translations["MSG_CREATOR_PUBLISH_CANCEL_BTN"] = "キャンセル";
translations["MSG_CREATOR_PUBLISH_CONFIRM_BTN"] = "公開する";
translations["MSG_CREATOR_DISABLE_PUBLISH_CONFIRM_BTN"] = "非公開にする";
translations["MSG_CREATOR_APP_PUBLISHING"] = "公開中";
translations["MSG_CREATOR_APP_NOT_PUBLISHING"] = "非公開";
translations["MSG_CREATOR_APP_ENABLE_COPIED_TITLE"] =
  "このアプリのコピーの設定";
translations["MSG_CREATOR_APP_DISABLE_COPIED_TITLE"] =
  "このアプリのコピーの設定";
translations["MSG_CREATOR_APP_ENABLE_COPIED_MESSAGE"] =
  "他の人が「%{name}」をコピーできるようにコピーを許可します。";
translations["MSG_CREATOR_APP_DISABLE_COPIED_MESSAGE"] =
  "他の人が「%{name}」をコピーできないように、コピー禁止にします。";
translations["MSG_CREATOR_APP_LIMIT_WARNING_TITLE"] = "アプリをつくれません";
translations["MSG_CREATOR_APP_LIMIT_WARNING_MESSAGE"] =
  "今はアプリは５こまでしかつくれません。\n新しくアプリを作りたいときは、古いアプリを削除してください。\n５個以上アプリを作れるようになったら、お知らせします。";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_TITLE"] =
  "この画像は利用できません";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_MESSAGE"] =
  "アプリに追加できる画像は最新の５０個だけです。\nそれ以外の画像も利用できるようになりましたら、お知らせします。";
translations["MSG_CREATOR_TAG_LIMIT_WARNING_TITLE"] = "追加できません";
translations["MSG_CREATOR_TAG_LIMIT_WARNING_MESSAGE"] =
  "タグを追加できません。";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_TITLE"] =
  "アプリを削除できません";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_MESSAGE"] =
  "みんなのアプリに公開中のアプリは削除できません。\nこのアプリを削除したいときは、先に非公開にしてください。\n";
translations["MSG_CREATOR_TOP_TUTORIAL_APP_LIMIT_WARNING_TITLE"] =
  "「ガイド」を動かせません";
translations["MSG_CREATOR_TOP_TUTORIAL_APP_LIMIT_WARNING_MESSAGE"] =
  "この「ガイド」を見るためには、アプリの空が1つ必要です。\nこの「ガイド」を動かす前に、アプリを1つ削除してください。";
translations["MSG_CREATOR_APP_PUBLISH_DISABLE_WARNING_TITLE"] =
  "アプリを公開することが出来ませんでした。";
translations["MSG_CREATOR_APP_PUBLISH_DISABLE_WARNING_MESSAGE"] =
  "アプリの公開は許可されていません。\nアプリを公開したい場合は、保護者の人にお願いしてください。";
translations["MSG_CREATOR_APP_SORT_FILTER_TITLE"] = "見つける";
translations["MSG_CREATOR_APP_PUBLISHED_FILTER_OFFICIAL"] = "公式だけ表示";
translations["MSG_CREATOR_APP_PUBLISHED_FILTER_SORT_DATE"] = "新しい順";
translations["MSG_CREATOR_APP_PUBLISHED_FILTER_SORT_FAVORITED"] = "人気順";
translations["MSG_CREATOR_APP_PUBLISHED_FILTER_FAVORITED"] =
  "お気に入りだけ表示";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_TITLE"] = "言葉で見つける";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_PLACEHOLDER"] =
  "探したい言葉を入力";
translations["MSG_CREATOR_APP_SORT_TITLE"] = "並べ替え";
translations["MSG_CREATOR_APP_SORT_FAVORITED"] = "人気";
translations["MSG_CREATOR_APP_SORT_DATE"] = "時間";
translations["MSG_CREATOR_APP_FILTER_TITLE"] = "絞り込み";
translations["MSG_CREATOR_APP_FILTER_OFFICIAL"] = "公式";
translations["MSG_CREATOR_APP_FILTER_FAVORITED"] = "いいね";
translations["MSG_CREATOR_APP_DISABLE_BTN"] = "できません";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_TITLE"] =
  "アプリを完全に消しますか？";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_SUBTITLE"] =
  "「%{name}」を完全に消します。\n完全に消すと、アプリを元に戻すことはできなくなります。";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_TITLE"] =
  "「マイアプリ」に戻しますか？";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_SUBTITLE"] =
  "「%{name}」を「マイアプリ」に戻しますか？";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_MESSAGE"] =
  "※アプリは「非公開」の状態になります。\n   マイアプリに戻したあと、「公開」にできます。";

translations["MSG_CREATOR_SCREEN_LIST_HEADER"] = "ページ";
translations["MSG_CREATOR_COMPONENT_LIST_HEADER"] = "選択中";
translations["MSG_CREATOR_MENU_CONTEXT_DELETE"] = "削除";
translations["MSG_CREATOR_MENU_CONTEXT_COPY"] = "コピー";
translations["MSG_CREATOR_MENU_RUN_APP_BTN"] = "アプリを\nうごかす";
translations["MSG_CREATOR_MENU_SET_APP_BTN"] = "アプリの\n設定";
translations["MSG_CREATOR_MENU_PUBLISH_APP_BTN"] = "アプリを\n公開";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_APP_BTN"] = "アプリを\n非公開";
translations["MSG_CREATOR_MENU_PUBLISH_TEMPLATE_BTN"] = "テンプレートを\n公開";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_TEMPLATE_BTN"] =
  "テンプレートを\n非公開";
translations["MSG_CREATOR_MENU_CLOSE_BTN"] = "この画面を\n閉じる";
translations["MSG_CREATOR_MENU_GO_TO_EDITOR_BTN"] =
  "「アプリをつくる」\nの画面へ";
translations["MSG_CREATOR_MENU_BACK_TO_LIST_BTN"] = "一覧へ\n戻る";
translations["MSG_CREATOR_MENU_SHARE_BTN"] = "アプリを\nシェアする";
translations["MSG_CREATOR_MENU_COMPONENT_BTN"] = "パーツ";
translations["MSG_CREATOR_MENU_COMPONENT_ACTION_BTN"] = "お仕事";
translations["MSG_CREATOR_MENU_COMPONENT_SHAPE_BTN"] = "図形";
translations["MSG_CREATOR_MENU_COMPONENT_STAMP_BTN"] = "スタンプ";
translations["MSG_CREATOR_MENU_COMPONENT_STOCK_BTN"] = "道具箱";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_ACTION"] = "操作パーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_SHAPE"] = "図形パーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP"] = "スタンプパーツ";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_CHARACTER"] =
  "キャラクター";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GAME"] = "活動・遊び";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ANIMAL"] = "生き物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_EVENT"] = "イベント";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_INTERNET"] =
  "インターネット";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_MONEY"] = "経済・お金";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GOODS"] = "生活雑貨";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_NATURE"] = "自然・植物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_PERSON"] = "人物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_BUILDING"] = "建物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_FOOD"] = "食べ物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ELECTRONIC"] =
  "家電・通信";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_SMILE"] = "にこちゃん";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_VEHICLE"] = "乗り物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_STATIONARY"] = "文房具";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_OTHERS"] = "その他";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_PARTS_ALL"] = "全て";
translations["MSG_CREATOR_MENU_DRAWING_BTN"] = "お絵かき";
translations["MSG_CREATOR_MENU_DRAWING_PEN"] = "ペン";
translations["MSG_CREATOR_MENU_DRAWING_ERASER"] = "消しゴム";
translations["MSG_CREATOR_MENU_DRAWING_SIZE"] = "太さ";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_LIGHT"] = "細い";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_NORMAL"] = "普通";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_BOLD"] = "太い";
translations["MSG_CREATOR_MENU_DRAWING_SHAPE"] = "形";
translations["MSG_CREATOR_MENU_DRAWING_SHAPE_ROUND"] = "丸";
translations["MSG_CREATOR_MENU_DRAWING_SHAPE_SQUARE"] = "四角";
translations["MSG_CREATOR_MENU_DRAWING_COLOR"] = "色";
translations["MSG_CREATOR_MENU_DRAWING_RESET"] = "やり直す";
translations["MSG_CREATOR_MENU_DRAWING_FINISH"] = "完成";
translations["MSG_CREATOR_MENU_STOCK_PARTS_TITLE"] = "パーツセット";
translations["MSG_CREATOR_MENU_STOCK_PARTS_DETAIL_BTN"] = "詳しく";
translations["MSG_CREATOR_MENU_STOCK_PARTS_USE_BTN"] = "追加";
translations["MSG_CREATOR_MENU_COMPONENT_PREVIEW_TITLE"] =
  "%{name}のパーツ一覧";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_SYSTEM_TITLE"] = "アイコン";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "アルバム";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] =
  "スケッチブック";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_CREATE_TITLE"] = "素材追加";

translations["MSG_CREATOR_MENU_PROPERTY_BTN"] = "デザイン";
translations["MSG_CREATOR_MENU_PROPERTY_BASIC"] = "基本";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION"] = "場所";
translations["MSG_CREATOR_MENU_PROPERTY_SIZE"] = "サイズ";
translations["MSG_CREATOR_MENU_PROPERTY_SHAPE"] = "形";
translations["MSG_CREATOR_MENU_PROPERTY_APPEARANCE"] = "見た目";
translations["MSG_CREATOR_MENU_PROPERTY_COLOR"] = "色";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC"] = "プログラム";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC_TITLE"] = "%{name}のプログラム";

translations["MSG_CREATOR_MENU_PROPERTY_NAME"] = "名前";
translations["MSG_CREATOR_MENU_PROPERTY_NAME_PLACEHOLDER"] =
  "名前を付けてください";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE_TITLE"] = "トップページ";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE"] =
  "このページからはじめる";
translations["MSG_CREATOR_MENU_PROPERTY_FONT_FAMILY"] = "フォントの種類";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT"] = "表示する内容";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX"] = "重なり";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_FRONT"] = "一番上へ";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_BACK"] = "一番下へ";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION_X_Y"] = "横と縦の場所";
translations["MSG_CREATOR_MENU_PROPERTY_X"] = "横の場所";
translations["MSG_CREATOR_MENU_PROPERTY_Y"] = "縦の場所";
translations["MSG_CREATOR_MENU_PROPERTY_X_COORDINATE"] = "横";
translations["MSG_CREATOR_MENU_PROPERTY_Y_COORDINATE"] = "縦";
translations["MSG_CREATOR_MENU_PROPERTY_WIDTH"] = "横幅";
translations["MSG_CREATOR_MENU_PROPERTY_HEIGHT"] = "高さ";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER"] = "枠";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW"] = "影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SIZE"] = "テキスト";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW"] = "テキストの影";
translations["MSG_CREATOR_MENU_PROPERTY_OPACITY"] = "見えやすさ";
translations["MSG_CREATOR_MENU_PROPERTY_ROTATION"] = "角度";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_RADIUS"] = "角の丸さ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO"] = "画像の情報";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_NAME"] = "名前";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_SIZE"] = "大きさ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_FILE_SIZE"] =
  "ファイルサイズ";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_BTN"] = "画像を選ぶ";
translations["MSG_CREATOR_MENU_PROPERTY_BACKGROUND_COLOR"] = "塗りつぶし";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_COLOR"] = "枠";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW_COLOR"] = "影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_COLOR"] = "テキスト";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW_COLOR"] = "テキストの影";

translations["MSG_CREATOR_MENU_BLOCKLY_TITLE"] = "ブロック";
translations["MSG_CREATOR_MENU_BLOCKLY_EVENT"] = "イベント";
translations["MSG_CREATOR_MENU_BLOCKLY_ANIMATION"] = "動き";
translations["MSG_CREATOR_MENU_BLOCKLY_CONTROL"] = "制御";
translations["MSG_CREATOR_MENU_BLOCKLY_LOGIC"] = "ロジック";
translations["MSG_CREATOR_MENU_BLOCKLY_MATH"] = "演算";
translations["MSG_CREATOR_MENU_BLOCKLY_VARIABLE"] = "変数";
translations["MSG_CREATOR_MENU_BLOCKLY_PROCEDURE"] = "関数";
translations["MSG_CREATOR_MENU_BLOCKLY_NONE"] = "使えるブロックがありません";
translations["MSG_CREATOR_MENU_BLOCKLY_PROMPT_INPUT_MESSAGE"] =
  "%{placeholder}の値";

translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"] = "ページ";
translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"] = "ボタン";
translations["MSG_CREATOR_COMPONENT_NAME_LABEL"] = "ラベル";
translations["MSG_CREATOR_COMPONENT_NAME_FORM"] = "フォーム";
translations["MSG_CREATOR_COMPONENT_NAME_CHECKBOX"] = "チェックボックス";
translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"] = "スイッチ";
translations["MSG_CREATOR_COMPONENT_NAME_IMAGE"] = "画像";
translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"] = "円";
translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"] = "三角";
translations["MSG_CREATOR_COMPONENT_NAME_RECT"] = "四角";
translations["MSG_CREATOR_COMPONENT_NAME_STAR"] = "星";
translations["MSG_CREATOR_COMPONENT_NAME_LINE"] = "線";
translations["MSG_CREATOR_COMPONENT_NAME_STAMP"] = "スタンプ";
translations["MSG_CREATOR_COMPONENT_NAME_DRAWING"] = "お絵描き";

translations["MSG_CREATOR_COMPONENT_LABEL_SCREEN"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"];
translations["MSG_CREATOR_COMPONENT_LABEL_BUTTON"] =
  translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"];
translations["MSG_CREATOR_COMPONENT_LABEL_LABEL"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LABEL"];
translations["MSG_CREATOR_COMPONENT_LABEL_FORM"] =
  translations["MSG_CREATOR_COMPONENT_NAME_FORM"];
translations["MSG_CREATOR_COMPONENT_LABEL_CHECKBOX"] = "チェック\nボックス";
translations["MSG_CREATOR_COMPONENT_LABEL_SWITCH"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"];
translations["MSG_CREATOR_COMPONENT_LABEL_IMAGE"] = "画像\nボックス";
translations["MSG_CREATOR_COMPONENT_LABEL_CIRCLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_TRIANGLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_RECT"] =
  translations["MSG_CREATOR_COMPONENT_NAME_RECT"];
translations["MSG_CREATOR_COMPONENT_LABEL_STAR"] =
  translations["MSG_CREATOR_COMPONENT_NAME_STAR"];
translations["MSG_CREATOR_COMPONENT_LABEL_LINE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LINE"];

translations["MSG_BLOCKLY_VARIABLES"] = "変数";
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "数字を入力してください。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] =
  "%{limit}文字以内で入力してください。";

translations["MSG_BUILDER_MENU_PROPERTY_ASSET_BTN"] = "アセット";
translations["MSG_BUILDER_MENU_PROPERTY_BLOCK_BTN"] = "ブロック";
translations["MSG_BUILDER_MENU_ACTION_RUN_PREVIEW_BTN"] = "うごかす";
translations["MSG_BUILDER_MENU_ACTION_PUBLISH_BTN"] = "公開";
translations["MSG_BUILDER_MENU_ACTION_STOP_PUBLISH_BTN"] = "非公開";
translations["MSG_BUILDER_MENU_ACTION_UNDO_BTN"] = "取り消す";
translations["MSG_BUILDER_MENU_ACTION_REDO_BTN"] = "やり直す";
translations["MSG_BUILDER_MENU_ACTION_CLEAR_BTN"] = "クリア";

translations["MSG_ASSET_ALBUM_TITLE"] = "アルバムの中身";
translations["MSG_ASSET_DRAWING_TITLE"] = "スケッチブックの中身";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "画像の追加";
translations["MSG_ASSET_ALBUM_ADD_MESSAGE"] =
  "画像の追加　ここから画像（写真）の追加ができます。";
translations["MSG_ASSET_DRAWING_ADD_ALBUM_TITLE"] =
  "『まなんでパズル』で追加した、画像や写真がここに追加されます。";
translations["MSG_ASSET_DRAWING_ADD_WARNING_TITLE"] =
  "『じううにつくる』の「お絵かき」メニューで絵を書くと、ここに 追加されます。";
translations["MSG_ASSET_ADD_TO_SCREEN_BTN"] = "アプリに\n追加する";
translations["MSG_ASSET_APPLY_TO_COVER_PAGE_BTN"] = "表紙に\n設定";
translations["MSG_ASSET_APPLY_TO_PROFILE_ICON_BTN"] = "アイコンに\n設定";
translations["MSG_ASSET_DELETE_BTN"] = "画像を\n削除する";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] =
  "まだ 画像のデータがありません。";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] =
  "まだ お絵かきの データがありません。";

translations["MSG_ASSISTANT_WELCOME_MESSAGE"] =
  "こんにちは！アイロボ先生だよ！質問は何かな？話しかけてね！";

export default translations;
